import { create } from "zustand";
import { persist } from "zustand/middleware";
import { applyChartJsThemeDefaults } from "@/utils/chartTheme";

function getSystemPrefersDark() {
  return (
    typeof window !== "undefined" &&
    !!window.matchMedia?.("(prefers-color-scheme: dark)").matches
  );
}

export function resolveTheme(theme) {
  if (theme === "dark") return "dark";
  if (theme === "light") return "light";
  return getSystemPrefersDark() ? "dark" : "light";
}

export function applyTheme(theme) {
  if (typeof document === "undefined") return;

  const resolved = resolveTheme(theme);
  const root = document.documentElement;
  root.classList.toggle("dark", resolved === "dark");
  root.style.colorScheme = resolved;
  root.dataset.theme = theme;
  // Chart tooltips / axes follow theme wherever Chart.js is used
  queueMicrotask(() => applyChartJsThemeDefaults());
}

const useTheme = create(
  persist(
    (set, get) => ({
      theme: "system",
      setTheme: (theme) => {
        applyTheme(theme);
        set({ theme });
      },
      getResolvedTheme: () => resolveTheme(get().theme),
    }),
    {
      name: "theme-storage",
      getStorage: () => localStorage,
      onRehydrateStorage: () => (state) => {
        if (state?.theme) applyTheme(state.theme);
      },
    },
  ),
);

if (typeof window !== "undefined") {
  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const onChange = () => {
    if (useTheme.getState().theme === "system") applyTheme("system");
  };
  media.addEventListener?.("change", onChange);
}

export default useTheme;
